import request from './request'
import appConfig from './../config/app'

export default {
  namespaced: true,
  strict: appConfig.store.strict,
  state: {
    baseURL: appConfig.services.finance.baseURl,
    url: '/api/fee-category-basis',
    feeCategoryBasisList: []
  },
  mutations: {
    setList (state, payload) {
      state.feeCategoryBasisList = payload
    }
  },
  actions: {
    /**
     * Action to update field value
     *
     * @param {state, commit} commit
     * @param {payload} payload
     * @return void
     */
    async populateFeeCategoryBasisList ({ state, commit }) {
      const payload = {
        baseURL: state.baseURL,
        url: state.url
      }

      await request.get({}, payload)
        .then(({ data }) => {
          commit('setList', data)
        })
        .catch(({ response }) => {
          throw response
        })
    },
    /**
     * empty listing
     *
     * @param {commit} commit
     * @return void
     */
    async clearFeeCategoryBasisList ({ commit }) {
      commit('setList', [])
    }
  }
}
